export default __webpack_public_path__ + "static/miriama-huckova-b676c006d623ee65a03a9529600aa2f5.jpg";